import React, { useState } from "react";
import { useForm } from "react-hook-form";
import emailjs from "@emailjs/browser";

// import your components (keep if you had them)
import Header from "../Header";
import LogoCarousel from "../Logo";
import OfficeDetails from "../OfficeDetails";
import FooterWithMenu from "../Footer";

const ContactForm = () => {
  const [submitStatus, setSubmitStatus] = useState("");

  const {
    register,
    handleSubmit,
    reset,
  } = useForm();

  const onSubmit = (data) => {
    const serviceID = "service_x73q5ou";
    const templateID = "template_xi7zv6i";
    const publicKey = "XwVLpEjyvwsKPURsP";

    const templateParams = {
      fullName: data.fullName,
      email: data.email,
      phoneNumber: data.phoneNumber,
      companyName: data.companyName,
      service: data.service,
      message: data.message,
    };

    emailjs
      .send(serviceID, templateID, templateParams, publicKey)
      .then(() => {
        setSubmitStatus("success");
        reset();
      })
      .catch(() => {
        setSubmitStatus("error");
      });
  };

  return (
    <>
      <Header />

      <div className="py-12">
        <div className="w-[95%] md:w-[80%] mx-auto bg-white p-8 lg:p-12 rounded-lg shadow-md">

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

            {/* LEFT SIDE */}
            <div>
              <h1 className="text-2xl font-medium mb-4">
                Founders, business owners, innovators, creators...
                drop us a line, and let's make sparks fly.
              </h1>

              <p className="text-gray-600">
                Maybe you have an idea that you want to develop further.
                Maybe you have a brand that hasn’t yet reached its full potential.
                We’re all ears.
              </p>
            </div>

            {/* RIGHT SIDE FORM */}
            <div className="bg-[#FFFCF2] p-6 rounded-lg">

              <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">

                {/* Row 1 */}
                <div className="flex gap-4">
                  <input
                    {...register("fullName")}
                    placeholder="Full Name"
                    className="w-1/2 border-b p-2 bg-transparent outline-none"
                  />

                  <input
                    {...register("phoneNumber")}
                    placeholder="Phone Number"
                    className="w-1/2 border-b p-2 bg-transparent outline-none"
                  />
                </div>

                {/* Row 2 */}
                <div className="flex gap-4">
                  <input
                    {...register("email")}
                    placeholder="Email"
                    className="w-1/2 border-b p-2 bg-transparent outline-none"
                  />

                  <select
                    {...register("service")}
                    className="w-1/2 border-b p-2 bg-transparent outline-none"
                  >
                    <option value="">Select Interested Service</option>
                    <option value="Web Design">Web Design</option>
                    <option value="Branding">Branding</option>
                    <option value="Video Editing">Video Editing</option>
                  </select>
                </div>

                {/* Company */}
                <input
                  {...register("companyName")}
                  placeholder="Company Name"
                  className="w-full border-b p-2 bg-transparent outline-none"
                />

                {/* Message */}
                <textarea
                  {...register("message")}
                  placeholder="Message"
                  className="w-full border-b p-2 bg-transparent outline-none"
                  rows="4"
                />

                {/* Button */}
                <button
                  type="submit"
                  className="bg-orange-600 text-white px-6 py-3 rounded-full mt-4"
                >
                  SUBMIT
                </button>

                {/* ✅ SUCCESS MESSAGE */}
                {submitStatus === "success" && (
                  <p className="text-green-600 mt-3">
                    ✅ Form submitted successfully!
                  </p>
                )}

                {/* ❌ ERROR MESSAGE */}
                {submitStatus === "error" && (
                  <p className="text-red-500 mt-3">
                    ❌ Failed to send. Try again.
                  </p>
                )}

              </form>

            </div>

          </div>
        </div>
      </div>

      <LogoCarousel />
      <OfficeDetails />
      <FooterWithMenu />
    </>
  );
};

export default ContactForm;